var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTypeHeavyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.7 16l-3.2-4-13 16 3.1 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.6 0l-13 16 3.1 3.9 13-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 6.5l-13 16 2.4 3 13-16z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeHeavyIcon);
export default __webpack_public_path__ + "static/media/type-heavy-icon.aad40a5ca020b649b5e70204bdad5167.svg";
export { ForwardRef as ReactComponent };